<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :editConfig="{
        trigger: 'manual',
        mode: 'row',
        showStatus: true,
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame group-title">
            {{ '出库明细' }}
          </div>
        </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:fabricName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:wid="{ row }">
        <span>{{ row.wid }} </span>
        <span>{{ row.widUnit }}</span>
      </template>
      <template v-slot:fabricWeight="{ row }">
        <span>{{ row.fabricWeight }} </span>
        <span>{{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:unitPrice="{ row }">
        <span>{{ row.unitPrice }} </span>
        <span>{{ row.fabricUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    mainType: {
      type: String,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    tableData: {
      default: () => [],
    },
  },
  components: {
  },
  data() {
    return {
      loading: false,
      tablePage: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumn: [
     
        // { width: 50, fixed: 'left', type: this.single ? 'radio' : 'checkbox' },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'fabricColorNo',
          width: 200,
          title: '库存编号',
        },
        {
          field: 'fabricColorTitle',
          width: 200,
          title: '面料颜色名称',
        },
        {
          field: 'fabricName',
          minWidth: 300,
          title: '面料名称',
          slots: {
            default: 'fabricName',
          },
        },
        {
          field: 'requestQuantity',
          width: 100,
          title: '库存数量',
        },
        {
          field: 'outQuantity',
          minWidth: 150,
          title: '出库数量',
          showOverflow: true,
        },
        {
          field: 'unitPrice',
          width: 120,
          title:  '单价',
          slots: {
            default: 'unitPrice',
          },
        },
        {
          field: 'wid',
          width: 120,
          title:  '门幅',
          slots: {
            default: 'wid',
          },
        },
        {
          field: 'fabricWeight',
          width: 120,
          title:  '克重',
          slots: {
            default: 'fabricWeight',
          },
        },
        {
          field: 'userNameEn',
          width: 150,
          title:  '业务员',
        },
        {
          field: 'supName',
          minWidth: 300,
          title: '供应商',
        },
      ],
    }
  },
  methods: {
    fromLoad() {
      this.$refs.chooseFabricStock.load()
    },
    editRowEvent(row) {
      const $grid = this.$refs.table
      $grid.setActiveRow(row)
    },
    removeRowEvent(row) {
      let msg = '是否删除?'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let index = this.$refs.table.getRowIndex(row)
        this.tableData.splice(index, 1)
      })
    },
    getTableData() {
      return this.tableData
    },
    saveChooseCode(codeList) {
      let findCount = 0
      codeList.forEach((rowData) => {
        rowData.outQuantity = 0
        rowData.requestQuantity = rowData.stockQuantity

        this.tableData.forEach((item, index) => {
          if (rowData.fabricStockCode === item.fabricStockCode) {
            item.requestQuantity = rowData.stockQuantity
            this.$set(this.tableData, index, item)
            findCount++
          }
        })
        if (findCount === 0) {
          this.tableData.push(rowData)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
</style>
